import { useState, useCallback } from "react";
import {
	getImpersonatedEmail,
	setImpersonatedEmail,
	clearImpersonatedEmail,
} from "@gui/infrastructure/pass-through/storage";
import { resetFreshnessFloor } from "@gui/hooks/useFreshOnEntry";
import type { ImpersonationContextValue } from "./ImpersonationContext.types";

export function useImpersonationContextViewModel(): ImpersonationContextValue {
	const [impersonatedEmail, setImpersonatedEmailState] = useState<string | null>(() => getImpersonatedEmail());

	// Both directions switch identity via SPA state, with no reload to otherwise clear the
	// module-level freshness floor — without this, the impersonated user's page would read
	// with the admin's "already fresh" claims (and vice versa on stop).
	const startImpersonation = useCallback((email: string) => {
		setImpersonatedEmail(email);
		setImpersonatedEmailState(email);
		resetFreshnessFloor();
	}, []);

	const stopImpersonation = useCallback(() => {
		clearImpersonatedEmail();
		setImpersonatedEmailState(null);
		resetFreshnessFloor();
	}, []);

	return {
		impersonatedEmail,
		isImpersonating: impersonatedEmail !== null,
		startImpersonation,
		stopImpersonation,
	};
}
